import { render, staticRenderFns } from "./RefinancingCaseBankDetails.vue?vue&type=template&id=0c96a718"
import script from "./RefinancingCaseBankDetails.vue?vue&type=script&lang=js"
export * from "./RefinancingCaseBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports